import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const onUpdate = (message) => {
    const event = new CustomEvent("serviceWorkerEvent", { detail: message });
    window.dispatchEvent(event);
};

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

registerServiceWorker(onUpdate);



// WEBPACK FOOTER //
// ./src/index.js